import { render, staticRenderFns } from "./StudentJob.vue?vue&type=template&id=9954fb9e&scoped=true&"
import script from "./StudentJob.vue?vue&type=script&lang=js&"
export * from "./StudentJob.vue?vue&type=script&lang=js&"
import style0 from "./StudentJob.vue?vue&type=style&index=0&id=9954fb9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9954fb9e",
  null
  
)

export default component.exports